import Marquee from "react-fast-marquee";
import trademarkImg from "../../assets/images/Trade-mark-Registration.png";
import trademarkImg2 from "../../assets/images/trademark-Registration-Process.png";
import trademark_og_Img from "../../assets/og-img/trademark.png";
import Faq from "../../components/Faq";
import Meta from "../../components/Meta";
import { intellectualRelatedArticales } from "../../data/relatedArticale";
import { trademarkClasses } from "./data";

export default function TradeMarkClass() {
  const faqItems = [
    {
      title: "What is a trademark class?",
      content: (
        <strong>
          A trademark class is a category of goods or services under which a
          trademark is registered. The classification system helps to organize
          trademarks into specific industries or types of products. Bangladesh
          follows the NICE Classification system, which includes 45 classes — 34
          for goods and 11 for services.
        </strong>
      ),
    },
    {
      title: "Why is trademark classification important?",
      content: (
        <strong>
          Trademark classification ensures that your brand is protected in the
          correct category of goods or services. This avoids conflicts and
          ensures that similar names in unrelated industries do not affect your
          rights. Choosing the right class is crucial for legal protection and
          enforcement.
        </strong>
      ),
    },
    {
      title: "How many trademark classes are there in Bangladesh?",
      content: (
        <strong>
          Bangladesh uses the NICE Classification system, which includes 45
          classes:
          <br />
          - 34 classes for goods (Class 1–34)
          <br />
          - 11 classes for services (Class 35–45)
          <br />A trademark can be registered in one or multiple classes
          depending on the business scope.
        </strong>
      ),
    },
    {
      title: "Can I register my trademark under multiple classes?",
      content: (
        <strong>
          Yes. If your business operates in multiple categories (e.g., clothing,
          cosmetics, and online retail), you can apply for trademark
          registration in multiple classes. Each class requires a separate fee
          and application.
        </strong>
      ),
    },
    {
      title: "What are some common trademark classes in Bangladesh?",
      content: (
        <strong>
          Here are a few frequently used trademark classes:
          <br />
          - Class 3: Cosmetics and cleaning products
          <br />
          - Class 5: Pharmaceuticals
          <br />
          - Class 9: Electronics and software
          <br />
          - Class 25: Clothing and footwear
          <br />
          - Class 35: Advertising and business services
          <br />
          - Class 41: Education and entertainment services
          <br />- Class 43: Restaurants and hotel services
        </strong>
      ),
    },
    {
      title: "Where do I apply for trademark registration in Bangladesh?",
      content: (
        <strong>
          Trademark registration in Bangladesh is handled by the Department of
          Patents, Designs and Trademarks (DPDT) under the Ministry of
          Industries. You must choose the correct class before submitting the
          application.
        </strong>
      ),
    },
  ];

  return (
    <>
      <Meta
        title={`Trademark Class List in Bangladesh ${new Date().getFullYear()} | Trademark Search`}
        description="In Bangladesh, trademark classifications are divided into 45 classes, with Classes 1-34 covering goods and Classes 35-45 covering services. The Trademarks Rules, 1963 outline the system, and applications are processed by the Department of Patents, Designs and Trademarks (DPDT)."
        image={trademark_og_Img}
        keywords="trademark class, trademark class in Bangladesh, trademark registration, trademark registration cost in bangladesh, trademark registration online bd, trademark search online bangladesh, trademark search bangladesh"
      />

      <div className="container-fluid hero-header bg-light py-5 mb-5">
        <div className="container py-5">
          <div className="row g-5 align-items-center">
            <div className="col-lg-6">
              <h1 className="display-4 mb-3 animated slideInDown">
                Trademark class
              </h1>
              <>
                In Bangladesh, trademark classifications are divided into 45
                classes, with Classes 1-34 covering goods and Classes 35-45
                covering services. The Trademarks Rules, 1963 outline the
                system, and applications are processed by the Department of
                Patents, Designs and Trademarks (DPDT).
              </>
            </div>
            <div className="col-lg-6 animated fadeIn">
              <img
                className="img-fluid animated pulse infinite"
                style={{ animationDuration: "3s" }}
                src={trademarkImg}
                alt="Trade-mark-Registration"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="container-xxl py-5">
        <div className="container">
          <p className="color-text fs-5 mb-4">
            <b>Trademark Registration in Bangladesh</b>
          </p>
          <p>
            In Bangladesh, trademark registration is governed by the Trademarks
            Act, 2009 and follows the Nice Classification System (Nice
            Agreement), which is an international system of classifying goods
            and services for the registration of marks. There are a total of 45
            classes—34 for goods (Class 1 to 34) and 11 for services (Class 35
            to 45). Each trademark must be registered under the specific
            class(es) relevant to the product or service it represents. Choosing
            the correct class is essential to ensure appropriate legal
            protection.
          </p>
        </div>
      </div>

      <div className="container-xxl py-5">
        <div className="container">
          <div className="row g-5 align-items-center">
            <div className="col-lg-6  ">
              <img
                className="img-fluid"
                src={trademarkImg2}
                alt="trademark-Registration-Process"
              />
            </div>
            <div className="col-lg-6  ">
              <div className="h-100">
                <p className="color-text fs-5 mb-4">TM Search</p>
                <p>
                  The applicant may conduct a search for similar trademarks with
                  the DPDT. This is not mandatory for the registration of
                  trademarks.
                </p>
                <p className="color-text fs-5 mb-4">
                  Application of Trademark Registration
                </p>
                <p>
                  <div className="d-flex align-items-center mb-2">
                    <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                    <span>
                      An application for the registration of a trademark shall
                      include the following-
                    </span>
                  </div>
                  <div className="d-flex align-items-center mb-2">
                    <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                    <span>
                      Name of the Mark /Logo/Device prints or representation.
                    </span>
                  </div>
                  <div className="d-flex align-items-center mb-2">
                    <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                    <span>Name of the Applicant.</span>
                  </div>
                  <div className="d-flex align-items-center mb-2">
                    <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                    <span>Address and nationality of the Applicant.</span>
                  </div>
                  <div className="d-flex align-items-center mb-2">
                    <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                    <span>
                      Status of the applicant i.e. Merchandisers / Manufacturers
                      /Service Providers
                    </span>
                  </div>
                  <div className="d-flex align-items-center mb-2">
                    <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                    <span>Specification of Goods/Services and Class.</span>
                  </div>
                  <div className="d-flex align-items-center mb-2">
                    <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                    <span>
                      User date of the mark (whether the mark is in use or
                      proposed to be used in Bangladesh).
                    </span>
                  </div>
                  <div className="d-flex align-items-center mb-2">
                    <i className="fa fa-check bg-light color-text btn-sm-square rounded-circle me-3 fw-bold" />
                    <span>
                      General/specific power of attorney may be required.
                    </span>
                  </div>
                </p>
                <p className="color-text fs-5 mb-4">
                  Acceptance or Rejection of Trademark by the Registrar
                </p>
                <p>
                  After filing the application, the Registrar may either accept
                  or reject or order to correct or modify the application. An
                  application for registration of a trade mark may be accepted
                  either absolutely or subject to conditions or limitations. The
                  Registrar, on receipt of the application, issues Official
                  Filing Receipt. The document contains all relevant filing
                  details on the trademark e.g. Application Number, date of
                  application, the trademark etc.). If the Registrar reject any
                  application, s/he should issue a show cause letter to the
                  applicant. The applicant must submit reply to the show cause
                  notice and may seek a hearing in the matter within three (3)
                  months otherwise, the application will be deemed abandoned.
                </p>
                <p className="color-text fs-5 mb-4">Journal Publication</p>
                <p>
                  After an application is accepted by the Registrar, s/he shall
                  provide a Journal Notification to the applicant for the
                  advertisement of the mark. Afterwards the applicant is
                  required to deposit journal fees though pay order/treasury
                  challah/bank draft. Then DPDT will send the mark to Bangladesh
                  Government Press (BG Press) for publication.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-xxl py-5">
        {trademarkClasses.map((item) => (
          <div key={item.class}>
            <p className="color-text fs-5 mb-4">
              Trademark Class {item.class}: {item.title}
            </p>
            <p>{item.description}</p>
          </div>
        ))}
      </div>

      <div className="container-xxl center-background1">
        <h2> Related Articles</h2>
      </div>

      <div className="container-xxl center-background1">
        <Marquee className="marquee-container">
          {intellectualRelatedArticales}
        </Marquee>
      </div>
      <div className="container py-5 my-0">
        <h2 className="color-text text-center mb-4">Trdaemark FAQ</h2>
        <Faq items={faqItems} />
      </div>
    </>
  );
}
